export const APP_INSIGHTS_INSTRUMENTATION_KEY = import.meta.env.SERVICE_BOOKER_LANDING_APP_INSIGHTS_INSTRUMENTATION_KEY || '';
export const CONNECTION_SCRIPT_PATH = import.meta.env.SERVICE_BOOKER_LANDING_CONNECTION_SCRIPT_PATH || '';
export const CLOUD_NAME = import.meta.env.SERVICE_BOOKER_LANDING_CLOUD_NAME || '';
